<template id="product">
  <div v-if="product.image != null" class="col-md-4 col-sm-4 col-xs-6">
    <div class="products">
      <a v-if="product.url && product.url != ''" :href="product.url">
        <div class="productsIcons"><img :src="product.image" alt="#"></div>
      </a>
      <div v-else class="productsIcons"><img :src="product.image" alt="#"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'product',
  props:['product'],
  data () {
    return {
    }
  },
  components: {
  },
  methods: {
  },
  mounted: function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Product.vue